import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_CHECK_IN_DATE, STR_CHECK_OUT_DATE, STR_CUSTOMER, STR_DAY, STR_DAYS, STR_HOTEL, STR_OVERALL_COST, STR_PAID, STR_PAYMENT_METHOD, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_RECEIPT, STR_ROOM_2, STR_SUBSCRIPTION_HAS_EXPIRED, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEEs, STR_UNPAID } from "../Strings";
import { MdCall, MdHotel, MdMessage, MdTimer, MdTimer10, MdTimeToLeave, MdWhatsapp } from "react-icons/md";
import { TbBrandDaysCounter } from "react-icons/tb";

export default function RoomOrderReceipt({ data, customerData }) {
	const appContext = useContext(AppContext);

	/* Place states here */



	return (
		<div className="">
			
			<div
				style={{
					maxWidth: "300px",
					margin: "0 auto",
					padding: "10px",
					borderTop: "3px dotted black",
					borderBottom: "3px dotted black",
				}}
				className="bg-surface font-regular-roboto"
			>
				<h6
					className="font-bold-roboto text-muted text-center"
					style={{
						fontSize: "22px",
						textTransform: "uppercase"
					}}
				>
					{STR_RECEIPT[appContext.language]}
				</h6>
				<h6
					className="text-center font-light-roboto"
					style={{
						fontSize: "32px"
					}}
				>
					AVAN Hotels
				</h6>
				

				<div className="row">

					<div className="col-12 mt-5 mb-2">
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{formatDate(data.dateCreated)}
						</h6>
					</div>

					<div className="col-6 mt-2 mb-3">
						<h6
							className="font-bold-roboto"
							style={{
								fontSize: "12px",
								textTransform: "uppercase"
							}}
						>
							{STR_HOTEL[appContext.language]}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{data.hotelName}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{STR_ROOM_2[appContext.language]}: {data.hotelRoomName}
						</h6>
					</div>

					<div className="col-6 mt-2 mb-3">
						<h6
							className="font-bold-roboto"
							style={{
								fontSize: "12px",
								textTransform: "uppercase"
							}}
						>
							{STR_CUSTOMER[appContext.language]}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{customerData.fullname}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{customerData.phone}
						</h6>
					</div>

					<div className="col-6 mt-2 mb-2">
						<h6
							className="font-bold-roboto"
							style={{
								fontSize: "12px",
								textTransform: "uppercase"
							}}
						>
							{STR_CHECK_IN_DATE[appContext.language]}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{data.checkInDate}
						</h6>
					</div>

					<div className="col-6 mt-2 mb-2">
						<h6
							className="font-bold-roboto"
							style={{
								fontSize: "12px",
								textTransform: "uppercase"
							}}
						>
							{STR_CHECK_OUT_DATE[appContext.language]}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{data.checkOutDate}
						</h6>
					</div>

					<div className="col-6 mt-2 mb-2">
						<h6
							className="font-bold-roboto"
							style={{
								fontSize: "12px",
								textTransform: "uppercase"
							}}
						>
							{STR_DAYS[appContext.language]}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{data.numberOfDays}
						</h6>
					</div>

					<div className="col-6 mt-2 mb-2">
						<h6
							className="font-bold-roboto"
							style={{
								fontSize: "12px",
								textTransform: "uppercase"
							}}
						>
							{STR_PAYMENT_METHOD[appContext.language]}
						</h6>
						<h6
							className=""
							style={{
								fontSize: "14px"
							}}
						>
							{data.payWith}
						</h6>
					</div>

					<div className="col-12 mt-3 mb-3">
						<table className="table table-striped">
							<thead>
								<tr>
									<th></th>
									<th className="text-end">TZS</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style={{ fontSize: "14px" }}>{STR_TOTAL_ORDER_PRICE[appContext.language]}</td>
									<td className="text-end">{formatMoney(Math.floor(data.totalOrderPrice))}</td>
								</tr>

								<tr>
									<td style={{ fontSize: "14px" }}>{STR_TRANSACTION_FEEs[appContext.language]}</td>
									<td className="text-end">{formatMoney(Math.floor(data.transactionFees))}</td>
								</tr>

								<tr>
									<td style={{ fontSize: "14px" }}>{STR_OVERALL_COST[appContext.language]}</td>
									<td style={{ fontSize: "18px" }} className="text-end font-semi-bold-roboto">{formatMoney(Math.floor(data.overallCost))}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div className="col-12">
						
						<h6
							className="text-center font-bold-roboto"
							style={{
								padding: "20px",
								border: (data.isPaid === 'yes') ? "6px solid green" : "6px solid red",
								color: (data.isPaid === 'yes') ? "green" : "red",
								textTransform: "uppercase",
								fontSize: "28px"
							}}
						>							
							{(data.isPaid === 'yes') ? STR_PAID[appContext.language] : STR_UNPAID[appContext.language]}
						</h6>

					</div>
					
				</div>
			</div>
		</div>
	);
}
